import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'aa-content-actions',
    templateUrl: './content-actions.component.html',
    styleUrls: ['./content-actions.component.scss'],
    standalone: false
})
export class ContentActionsComponent implements OnInit
{
    constructor() { }

    ngOnInit ()
    {
    }
}
